import moment from 'moment'

export default {
    name: 'datepicker',
    props: {
        dateStart: {
            type: String,
        },
        dateEnd: {
            type: String,
        },
        lang: {
            type: String,
            default: 'en'
        }
    },
    data() {
        return {
            days: {
                en: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
                ru: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
            },
            today: moment().startOf('day'),
            selectedMonth: moment().startOf('month').format(),
            selectedDateStart: this.dateStart,
            selectedDateEnd: this.dateEnd,
        }
    },
    computed: {
        month() {
            moment.locale(this.lang)

            let month = []
            let week = []
            let date = moment(this.selectedMonth)
            let daysInMonth = date.daysInMonth()
            let dayIndex = date.weekday()
            let count = daysInMonth + dayIndex

            if (count % 7 > 0)
                count += (7 - count % 7)

            date = date.subtract(dayIndex, 'days')

            for (let i = 1; i <= count; i++) {
                let otherMonth = (i < dayIndex + 1) || (i >= daysInMonth + dayIndex + 1)

                week.push({
                    date: date.format(),
                    num: date.format('D'),
                    disabled: otherMonth || date > moment().endOf('day'),
                    otherMonth: otherMonth,
                    today: this.today.isSame(date),
                    limitDate: date.isSame(moment(this.selectedDateStart)) || date.isSame(moment(this.selectedDateEnd).startOf('day'))
                })

                if ( i % 7 === 0) {
                    month.push(week)
                    week = []
                }

                date.add(1, 'days')
            }

            return month
        },
    },
    methods: {
        prevMonth() {
            this.selectedMonth = moment(this.selectedMonth).subtract(1, 'months').format()
        },
        nextMonth() {
            this.selectedMonth = moment(this.selectedMonth).add(1, 'months').format()
        },
        selectDate(day) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                this.selectedDateStart = day.date
                this.selectedDateEnd = null
            } else if ( ! this.selectedDateEnd) {
                if (moment(day.date) < moment(this.selectedDateStart)) {
                    this.selectedDateEnd = this.selectedDateStart
                    this.selectedDateStart = day.date
                } else
                    this.selectedDateEnd = day.date
            }
        },
        isSelected(date) {
            if (this.selectedDateStart && this.selectedDateEnd) {
                return moment(date) >= moment(this.selectedDateStart) && moment(date) <= moment(this.selectedDateEnd)
            } else if ( ! this.selectedDateEnd) {
                return moment(date).isSame(moment(this.selectedDateStart))
            }
        },
        submit() {
            let end = this.selectedDateEnd ? moment(this.selectedDateEnd).endOf('day').format() : moment(this.selectedDateStart).endOf('day').format()
            this.$emit('select', { start: this.selectedDateStart, end: end })
        },
        cancel() {
            this.$emit('cancel')
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/datepicker/datepicker.js